<template>
  <div class="home-page">
    <!-- 轮播图 -->
    <div class="banner-wrapper">
      <Carousel
        v-model="carouselIndex"
        autoplay
        :autoplay-speed="5000"
        loop
        radius-dot
      >
        <CarouselItem>
          <img
            class="banner-img"
            src="../../static/img/home/banner4.png"
            alt="banner"
          />
        </CarouselItem>
        <CarouselItem>
          <img
            class="banner-img"
            src="../../static/img/home/banner1.jpg"
            alt="banner"
          />
        </CarouselItem>
        <CarouselItem>
          <img
            class="banner-img"
            src="../../static/img/home/banner2.jpg"
            alt="banner"
          />
        </CarouselItem>
        <CarouselItem>
          <img
            class="banner-img"
            src="../../static/img/home/banner3.jpg"
            alt="banner"
          />
        </CarouselItem>
      </Carousel>
    </div>
    <!-- 核心优势 -->
    <section class="core-section">
      <div class="container">
        <div class="section-title">
          <h2>核心优势</h2>
          <p class="desc">
            高度智能化，建筑数据全面信息化，高水平的安全保障能力，行业一流的管理与服务。
          </p>
          <div class="title-line"></div>
        </div>
        <div class="core-list">
          <div class="core-item" v-for="(item, i) in coreList" :key="i">
            <div class="icon-wrap">
              <img class="icon" :src="item.icon" alt="" />
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 南秀产业 -->
    <div class="industry-section">
      <div class="container industry-layout">
        <div class="industry-left">
          <h2 class="white-title">南秀产业</h2>
          <div class="title-line white-line"></div>
          <p class="industry-desc">
            提供全面的智能施工解决方案 包括传感器、云计算和大数据分析等技术
            让我们一起创造更加智慧、高效和可持续的建设行业
          </p>
        </div>
        <div class="industry-item" v-for="(item, i) in industryList" :key="i">
          <div class="vertical-title-wrap">
            <div class="vertical-title">{{ item.title }}</div>
          </div>
          <div class="number">{{ item.num }}</div>
        </div>
      </div>
    </div>
    <!-- 新闻资讯 -->
    <section class="news-section">
      <div class="container">
        <div class="section-title">
          <h2>新闻资讯</h2>
          <div class="title-line"></div>
        </div>
        <div class="news-layout" v-if="NewsData.length">
          <div class="news-main">
            <div class="news-item-large" @click="getSkip(NewsData[0].id)">
              <div class="img-box">
                <img :src="NewsData[0].fileUrls" alt />
                <div class="date">{{ NewsData[0].publishDate | format }}</div>
              </div>
              <div class="info">
                <h3 class="title">{{ NewsData[0].title }}</h3>
                <p class="sub-title">{{ NewsData[0].subTitle }}</p>
              </div>
            </div>
          </div>
          <div class="news-list">
            <div
              class="news-item-small"
              v-for="(item, idx) in NewsData.slice(1, 5)"
              :key="idx"
              @click="getSkip(item.id)"
            >
              <div class="date-box">
                <div class="date-lg">{{ item.publishDate | formatDates }}</div>
                <div class="date-sm">{{ item.publishDate | formatDate }}</div>
              </div>
              <div class="split-line"></div>
              <div class="content">
                <h4>{{ item.title }}</h4>
                <p>{{ item.subTitle }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 关于我们 -->
    <section class="about-section">
      <div class="about-pc">
        <div class="about-bg">
          <div class="container">
            <div class="about-content">
              <div class="about-text-wrap">
                <div class="about-title-wrap">
                  <h2>关于我们</h2>
                  <div class="title-line"></div>
                  <p class="company-name">河南南秀数智科技有限公司</p>
                </div>
                <div class="about-desc-text">
                  <p>
                    河南南秀智数科技有限公司（简称：南秀科技）成立于2017年，总部位于郑州市郑东新区龙子湖中原数据产业大厦。技术服务范围广泛，涵盖数字孪生平台、人工智能、集成电路、智能物联网、大数据、云计算、虚拟仿真软硬件，以及
                    VR、AR、MR
                    技术研发。公司将物联网、大数据与行业深度融合，为客户提供全流程数字化的管理工具和创新展示平台，助力行业效率与安全水平全面提升。公司以致力于建筑行业与消防安全数字化为宗旨，竭诚奉献领先的数字化产品与服务，至今已与中建、中铁、中交、中冶等100余家单位建立了良好的合作关系。
                  </p>
                  <p>
                    公司于2019年被评为国家高新技术企业，2020年完成知识产权贯标，2021年被认定为郑州市大数据企业，并获得"专精特新"南秀科技自成立以来，专注于技术研发与创新应用。2019年，南秀科技被评为国家高新技术企业。2020年完成知识产权贯标工作，为企业发展提供了有力支撑。2021年，南秀科技被认定为郑州市大数据企业，并获得“专精特新”中小企业认证及AAA级信用等级认证。拥有9项发明专利、32项实用新型专利和58项软件著作权，SCI论文2篇、独立研发出40余项完全自主知识产权的产品。2023年5月，我司与中建五局共同研发的《工程项目数字孪生智能建造系统》荣获河南省科技厅科学技术一等奖。带领团队获得第二届全国大学生智能技术应用大赛一等奖；2024年公司与中建七局、中建五局共同申报的《工程项目数字孪生智能建造关键技术及应用》经河南省院士专家工作促进会认定，具有较高的市场推广应用潜力。该成果在工程项目数字孪生系统构建等方面有重大创新，达到国际先进水平，同时本项目荣获了
                    2024
                    年中州建设科学技术奖一等奖；我司研发的实测实量智能管控系统平台通过二级等保评测；公司的数字孪生智慧平台通过SQuaRE(GB/T
                    25000.51-2016)《系统与软件工程系统与软件质量要求和评价(SQuaRE)第51部分:就绪可用软件产品(RUSP)的质量要求和测试细则》评测。2024年在第一届住房城乡建设部智能建造工程技术创新中心智能建造大赛中，南秀科技参与研发的
                    “基于人工智能的施工现场全场景关键技术及穿戴设备—AI
                    移动巡检安全帽”
                    项目成功突围，荣获住建部智能建造大赛三类成果奖项，以及2025年豫建杯智能建造微创新技术大赛特等奖；公司先后被授予“河南省智能建造专业委员会委员单位”、荣获河南建筑业第四届供应链“十大优秀服务商”、荣获河南省建设信息管理协会“副会长单位”，深度参与《河南省建设工程智慧工地建设与评价标准》及《河南省建设工程智慧工地建设与评价共享交换数据标准》两项标准的制定。2025年带领企业深度参与共建河南省省级工程研究中心—河南省物证溯源数智化应用程研究中心。
                  </p>
                </div>
                <div class="more-btn" @click="goAbout">查看更多></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about-mobile">
        <div class="mobile-content">
          <h3>关于我们</h3>
          <p class="en">About us</p>
          <div class="content">
            <h4>公司简介</h4>
            <p>
              河南南秀数智科技有限公司旨在为建筑行业提供专业的VR技术服务、AR技术服务，建筑数据信息化服务等。公司地处郑州市郑东新区，地理位置优越，交通便利。公司内部拥有精通VR、AR、互动操作台、智能机器人、电子沙盘、建筑数据信息化平台等相关技术各项应用的高端技术人才团队，为您提供完整的三维可视化解决方案，体验震撼的虚拟现实环境、触摸操作三维景观，体验多种建筑智能化设备硬件产品。
            </p>
            <div class="more-btn" @click="goAbout">详情>></div>
          </div>
        </div>
      </div>
    </section>
    <!-- 合作伙伴 -->
    <section class="partner-section">
      <div class="container">
        <div class="section-title">
          <h2>合作伙伴</h2>
          <p class="desc">开放合作，共赢生态发展，共创产业价值</p>
          <div class="title-line"></div>
        </div>
        <PartnerScroll :list="partnerList" :speed="0.6" />
      </div>
    </section>
  </div>
</template>
<script>
import { formatDate } from "@/utils/filters";
import PartnerScroll from "@/utils/PartnerScroll.vue";
export default {
  name: "Home",
  filters: {
    format(time) {
      return time ? formatDate(new Date(time), "yyyy-MM-dd") : "";
    },
    formatDates(time) {
      return time ? formatDate(new Date(time), "MM/dd") : "";
    },
    formatDate(time) {
      return time ? formatDate(new Date(time), "yyyy") : "";
    },
  },
  components: {
    PartnerScroll,
  },
  data() {
    return {
      carouselIndex: 0,
      page: { page: 1, size: 5 },
      NewsData: [],
      coreList: [
        {
          icon: require("../../static/img/home/large-scale.png"),
          title: "公司规模化",
          desc: "公司规模化发展，凭借专业团队、庞大的运营规模以及完备的设备设施，为客户提供卓越的服务与产品。",
        },
        {
          icon: require("../../static/img/home/team.png"),
          title: "专业化团队",
          desc: "公司拥有精通AI移动巡检、光伏清扫机器人、智慧工地平台等相关技术各项应用的高端技术人才团队，确保服务质量。",
        },
        {
          icon: require("../../static/img/home/research.png"),
          title: "技术研发",
          desc: "提供完整的三维可视化解决方案，体验震撼的虚拟现实环境、触摸操作三维景观，体验多种建筑智能化设备硬件产品。",
        },
        {
          icon: require("../../static/img/home/specification.png"),
          title: "体系规范",
          desc: "研发体系规范是我们公司专业性的核心体现，它确保了研发流程的标准化、高效化和质量化，为公司持续创新提供了坚实的基础。",
        },
      ],
      industryList: [
        { title: "数字孪生", num: "01" },
        { title: "智慧展厅", num: "02" },
        { title: "安全体验", num: "03" },
        { title: "AI智能巡检", num: "04" },
        { title: "光伏清扫机器人", num: "05" },
      ],
      partnerList: [
        { url: require("../../static/img/Content/Friend/jianzhu10.png") },
        { url: require("../../static/img/Content/Friend/jianzhu11.png") },
        { url: require("../../static/img/Content/Friend/jianzhu12.png") },
        { url: require("../../static/img/Content/Friend/11.png") },
        { url: require("../../static/img/Content/Friend/jianzhu01.png") },
        { url: require("../../static/img/Content/Friend/jianzhu02.png") },
        { url: require("../../static/img/Content/Friend/jianzhu03.png") },
        { url: require("../../static/img/Content/Friend/jianzhu04.png") },
        { url: require("../../static/img/Content/Friend/jianzhu05.png") },
        { url: require("../../static/img/Content/Friend/jianzhu07.png") },
        { url: require("../../static/img/Content/Friend/jianzhu09.png") },
      ],
    };
  },
  mounted() {
    this.getNews();
  },
  methods: {
    async getNews() {
      const res = await this.$axios.get(
        "/api/preHandleCtrl/getContentByPages",
        {
          params: {
            page: this.page.page,
            size: this.page.size,
            categoryId: 1,
          },
        }
      );
      this.NewsData = res.data.data.resultData || [];
    },
    getSkip(id) {
      this.$router.push({ name: "NewsDetails", query: { id } });
    },
    goAbout() {
      this.$router.push("/home/AboutUs");
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.home-page {
  width: 100%;
  overflow-x: hidden;
}
/* 【优化1：容器改为全屏宽版，取消22%左边距，企业官网标准1400px大容器】 */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}
.banner-wrapper {
  width: 100%;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
.section-title {
  margin-bottom: 50px;
  text-align: left;
}
.section-title h2 {
  font-size: 32px;
  font-weight: 700;
  color: #2a2a2a;
  margin-bottom: 12px;
}
.section-title .desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 14px;
  line-height: 1.8;
}
.title-line {
  display: flex;
  gap: 6px;
  align-items: center;
}
.title-line::before {
  content: "";
  width: 80px;
  height: 4px;
  background: #1966ff;
}
.title-line::after {
  content: "";
  width: 4px;
  height: 4px;
  background: #1966ff;
}
.title-line.white-line::before,
.title-line.white-line::after {
  background: #ffffff;
}
.white-title {
  color: #fff;
  font-size: 32px;
}
/* 核心优势区域加大上下内边距，卡片美化 */
.core-section {
  padding: 80px 0;
  background: #fff;
}
.core-list {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
}
.core-item {
  width: 100%;
  max-width: 300px;
  padding: 40px 25px;
  text-align: center;
  border-radius: 12px;
  transition: all 0.4s ease;
  background-color: #fff;
}
.core-item .icon-wrap {
  margin-bottom: 20px;
}
.core-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(25, 102, 255, 0.12);
}
.core-item .icon {
  width: 120px;
  height: 120px;
}
.core-item h3 {
  font-size: 22px;
  color: #222;
  margin-bottom: 12px;
}
.core-item p {
  font-size: 15px;
  color: #666;
  line-height: 1.8;
}
/* 产业区块加高留白 */
.industry-section {
  background: url("../../static/img/home/core.png") center/cover no-repeat;
  padding: 80px 0;
  color: #fff;
}
.industry-layout {
  display: flex;
  max-width: 1400px;
  margin: 0 auto;
}
.industry-left {
  width: 30%;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  padding-right: 40px;
}
.industry-desc {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  margin-top: 24px;
  font-size: 16px;
}
.industry-item {
  flex: 1;
  text-align: center;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 320px;
  padding: 0 15px;
  transition: 0.3s;
}
.industry-item:hover {
  background-color: rgba(25, 102, 255, 0.15);
}
.industry-item:last-child {
  border-right: none;
}
.vertical-title-wrap {
  display: flex;
  justify-content: center;
  height: 220px;
}
.industry-item .vertical-title {
  font-size: 28px;
  line-height: 1.4;
  writing-mode: vertical-lr;
  white-space: nowrap;
}
.industry-item .number {
  font-size: 56px;
  font-weight: bold;
  padding-bottom: 20px;
}
/* 新闻区域加大padding */
.news-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}
.news-item-large {
  cursor: pointer;
}
.news-item-large .img-box {
  position: relative;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 12px;
}
.news-item-large .img-box img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.4s ease;
}
.news-item-large:hover .img-box img {
  transform: scale(1.05);
}
.news-item-large .img-box .date {
  position: absolute;
  bottom: 0;
  left: 0;
  background: #3e5edc;
  color: #fff;
  padding: 6px 16px;
  font-size: 14px;
}
.news-item-large .title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.news-item-large .sub-title {
  color: #666;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  line-height: 1.6;
}
.news-layout {
  display: flex;
  flex-direction: row !important;
  gap: 40px;
  align-items: stretch;
}
.news-main {
  width: 50%;
}
.news-list {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
}
.news-item-small {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 16px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  transition: 0.3s;
}
.news-item-small:hover {
  color: #3e5edc;
  background: #fff;
  border-radius: 8px;
}
.news-item-small .date-box {
  width: 80px;
  text-align: center;
}
.news-item-small .date-box .date-lg {
  font-size: 30px;
  font-weight: bold;
}
.news-item-small .date-box .date-sm {
  font-size: 14px;
}
.news-item-small .split-line {
  width: 1px;
  height: 50px;
  background: #ddd;
  margin: 0 16px;
}
.news-item-small .content {
  flex: 1;
}
.news-item-small .content h4 {
  font-size: 17px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.news-item-small .content p {
  font-size: 14px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.about-section {
  padding: 0;
  background: #fff;
}
.about-pc {
  display: block;
}
.about-bg {
  background: url("../../static/img/Content/timg.png") center/cover no-repeat;
  padding: 90px 0;
}
.about-content {
  padding-left: 0 !important;
}
.about-text-wrap {
  max-width: 700px;
  margin-left: 0;
}
.about-title-wrap {
  margin-bottom: 30px;
}
.about-title-wrap h2 {
  font-size: 32px;
  font-weight: 700;
  color: #2a2a2a;
  margin-bottom: 10px;
}
.company-name {
  font-size: 24px;
  font-weight: bold;
  color: #2a2a2a;
  margin-top: 14px;
}
.about-text-wrap p {
  line-height: 1.8;
  color: #444;
  margin-bottom: 14px;
  font-size: 16px;
  text-align: left;
}
.more-btn {
  display: inline-block;
  padding: 10px 24px;
  border: 1px solid #1966ff;
  color: #1966ff;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.3s;
  font-size: 15px;
}
.more-btn:hover {
  background: #1966ff;
  color: #fff;
}
.about-mobile {
  display: none;
  text-align: center;
  padding: 50px 20px;
}
.about-mobile h3 {
  font-size: 28px;
  margin-bottom: 10px;
}
.about-mobile .en {
  color: #0185d0;
  margin-bottom: 20px;
  font-size: 15px;
}
.about-mobile .content {
  text-align: left;
  max-width: 100%;
  margin: 0 auto;
}
.about-mobile .content h4 {
  font-size: 22px;
  color: #1b62b7;
  margin-bottom: 14px;
}
.about-mobile .content p {
  line-height: 1.8;
  color: #666;
  margin-bottom: 20px;
  font-size: 16px;
}
.partner-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}
.partner-carousel {
  display: flex;
  overflow: hidden;
  height: 130px;
  gap: 24px;
}
.partner-item {
  width: 180px;
  height: 120px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  padding: 10px;
}
.partner-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
/* 移动端适配 */
@media (max-width: 992px) {
  .section-title {
    margin-bottom: 35px;
  }
  .section-title h2 {
    font-size: 26px;
  }
  .white-title {
    font-size: 26px;
  }
  .about-pc {
    display: none !important;
  }
  .about-mobile {
    display: block !important;
  }
  .industry-layout {
    flex-direction: column !important;
  }
  .industry-left {
    width: 100% !important;
    border-right: none !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
    padding: 0 0 30px 0;
    margin-bottom: 30px !important;
  }
  .industry-item {
    width: 100% !important;
    border-right: none !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
    padding: 30px 0 !important;
    height: auto !important;
  }
  .industry-item:last-child {
    border-bottom: none !important;
  }
  .vertical-title-wrap {
    height: auto !important;
  }
  .vertical-title {
    writing-mode: horizontal-tb !important;
    font-size: 24px !important;
    margin: 0 auto 15px !important;
  }
  .number {
    font-size: 42px !important;
    margin-top: 15px !important;
  }
  .core-item {
    max-width: 100% !important;
    padding: 30px 20px !important;
  }
  .core-item .icon {
    width: 100px !important;
    height: 100px !important;
  }
  .news-layout {
    flex-direction: column !important;
    gap: 30px;
  }
  .news-main,
  .news-list {
    width: 100% !important;
  }
}
@media (max-width: 576px) {
  .partner-carousel {
    height: 100px;
  }
  .partner-item {
    width: 140px;
    height: 90px;
  }
}
.about-desc-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  line-height: 1.8;
}
.about-desc-text p {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue